// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2h0EY","addWidgetButton":"Header_addWidgetButton__2K-EO","dashboardTabs":"Header_dashboardTabs__2144h","active":"Header_active__3p-nm"};